import React, { useState, useRef } from 'react';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '~/services/api';
// Importando componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';

import { Container, Info } from './styles';

export default function Forgot() {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);

  async function handlerForgotPassword(data, { reset }) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        email: Yup.string()
          .email('Preencha um e-mail valido.')
          .required('Preencha o campo email.'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });
      await api.post('/password', {
        email: data.email,
      });
      reset();
      toast.success('Solicitação enviada com sucesso.');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('E-mail não cadastrado no sistema.');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <Info>Preencha com seu e-mail para recuperar senha !</Info>

      <Form ref={inputRef} onSubmit={handlerForgotPassword} autoComplete="off">
        <Input icon="MdEmail" label="E-mail" name="email" type="email" />
        <Button size="100%" load={carregar}>
          Recuperar
        </Button>
      </Form>
      <Link to="/">Voltar para tela de login</Link>
    </Container>
  );
}
